/* eslint-disable */

export enum SmsDeliveryMechanism {
  SMS_TEXT = "SMS_TEXT",
  VOICE = "VOICE",
}
